import { render, staticRenderFns } from "./HeadSort.vue?vue&type=template&id=2473c04a&"
import script from "./HeadSort.vue?vue&type=script&lang=js&"
export * from "./HeadSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports